import React, { useState } from 'react'
import ShowDemographics from './Demographics'
import PatientFinalNote from './PatientFinalNote'
import CustomAccordionComponent from '../../components/shared/CustomAccordionComponent'
import CAccordian from '../../components/shared/CAccordian'
import { CFormCheck, CButton, CSpinner } from '@coreui/react'
import ShowDetailNote from './ShowDetailNote'
import PatientNoteViewInModal from './PatientNoteViewInModal'

const DetailNote = ({
  addendum,
  noteStatus,
  setDataId,
  submitNotes,
  statusPatientNote = 'false',
  showMedicationLikeApp,
  showHrsInTreatment,
  showTreatmentAsAccordion,
  setModalVisible,
  formData,
  diagnosis,
  allLabs,
  patientID,
  diagnosisCode,
  selectedRisks,
  setSelectedRisks,
  MasterDiagnosisData,
  noteStructureRef,
  newmedsAdded,
  newLabsAdded,
  newImagingAdded,
  patientData,
  patientTreatments,
  hospitalRecords,
  patientDiagnosis,
  diagnosisAddedPinger,
  setHospitalRecords,
  patientSidebarActiveTab,
  allergies,
  setAllergies,
  personalHistory,
  setPersonalHistory,
  medication,
  setMedication,
  imaging,
  setImaging,
  activeTab,
  imagingTypeList,
  selectedDifferentialDiagnosis,
  noteID,
  handleSubmitModule,
  isAllotedToProvider,
  setSubmitLoader,
  submitLoader,
  setSelectedDifferentialDiagnosis,
  showComment,
  setAllHistory,
  setActiveTab,
}) => {
  const [isAcknowledged, setIsAcknowledged] = useState(false)
  const [showNote, setShowNote] = useState(true)
  const handleSubmit = () => {
    handleSubmitModule()
  }
  return (
    <div className="mx-5 d-flex flex-column h-100">
      <div className="position-relative">
        <ShowDetailNote formData={formData} diagnosis={diagnosis} setShowNote={setShowNote}></ShowDetailNote>
      </div>
      {showNote && (
        <div
          className="shadow-sm rounded p-3 mb-4"
          style={{
            maxHeight: '790px',
            overflow: 'auto',
            border: '1px solid var(--ui-dashboard-border, #ced4da)',
          }}
        >
          <PatientNoteViewInModal
            patientID={patientID}
            statusPatientNoteWasFollowUp={noteStatus && noteStatus === 'Follow Up' ? true : false}
            showHrsInTreatment={true}
            setDataId={setDataId}
            showTreatmentAsAccordion={true}
            showComment={showComment}
            submitNotes={submitNotes}
            setModalVisible={setModalVisible}
            formData={patientData}
            diagnosis={diagnosis}
            diagnosisCode={diagnosisCode}
            noteStructureRef={noteStructureRef}
            selectedRisks={selectedRisks}
            setSelectedRisks={setSelectedRisks}
            selectedDifferentialDiagnosis={selectedDifferentialDiagnosis}
            setSelectedDifferentialDiagnosis={setSelectedDifferentialDiagnosis}
            hospitalRecords={hospitalRecords}
            setHospitalRecords={setHospitalRecords}
            medication={medication}
            setMedication={setMedication}
            patientTreatments={patientTreatments}
            newImagingAdded={newImagingAdded}
            newLabsAdded={newLabsAdded}
            newmedsAdded={newmedsAdded}
            diagnosisAddedPinger={diagnosisAddedPinger}
            allergies={allergies}
            setAllergies={setAllergies}
            patientDiagnosis={patientDiagnosis}
            MasterDiagnosisData={MasterDiagnosisData}
            imagingTypeList={imagingTypeList}
            imaging={imaging}
            setImaging={setImaging}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            patientData={patientData}
            patientSidebarActiveTab={activeTab}
            personalHistory={personalHistory}
            setPersonalHistory={setPersonalHistory}
            allLabs={allLabs}
            noteID={noteID}
            showMedicationLikeApp={true}
            showToolbar={false}
            addendumData={addendum}
            showDataIfNoteIsFollowUp={noteID && noteID >= 0 ? true : false}
          ></PatientNoteViewInModal>
        </div>
      )}
      
      <div className="mt-auto">
        <style>{`
          .ack-container {
            margin-left: 3px !important;
          }
        `}</style>
        {showNote && (
          <div
            className="mb-4 d-flex align-items-center ack-container"
            style={{
              backgroundColor: 'transparent',
              color: 'white',
              paddingLeft: '2px',
            }}
          >
            <CFormCheck
              id="flexCheckDefault"
              label={<span style={{ color: 'var(--ui-text-primary, #fff)', fontWeight: 300 }}>I acknowledge that the information provided is accurate, complete, and has been reviewed and verified to the best of my knowledge.</span>}
              className="me-2 gap-4"
              style={{ transform: 'scale(1.3)', transformOrigin: 'left center' }}
              checked={isAcknowledged}
              onChange={(e) => setIsAcknowledged(e.target.checked)}
            />
          </div>
        )}
        <div className="d-flex justify-content-center gap-3" style={{ paddingBottom: '10px' }}>
          <CButton color="secondary" variant="outline" onClick={() => setModalVisible(false)}>
            Cancel
          </CButton>
          <CButton color="primary" disabled={!isAcknowledged} onClick={() => handleSubmitModule()}>
            {submitLoader && <CSpinner size="sm" color="light" className="me-2" />}
            Submit
          </CButton>
        </div>
      </div>
    </div>
  )
}

export default DetailNote
